import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-toolbar-button',
  templateUrl: './toolbar-button.component.html',
  styleUrls: ['./toolbar-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ToolbarButtonComponent implements OnInit {

  @Input() buttonClass: string | string[] | Set<string> | { [klass: string]: any; };

  constructor() { }

  ngOnInit() {
  }

}
